const ORACLE_ENVS = {
  ORACLE_MULTI_VIEW_SELECTED_ID: 'ORACLE_MULTI_VIEW_SELECTED_ID',

  // instance detail
  GRIDCOLUMNS_database_oracleInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_oracleInstanceDetail_activeSession',
  GRIDCOLUMNS_database_oracleInstanceDetail_sessionManager:
    'GRIDCOLUMNS_database_oracleInstanceDetail_sessionManager',
  GRIDCOLUMNS_database_oracleInstanceDetail_lockInfo:
    'GRIDCOLUMNS_database_oracleInstanceDetail_lockInfo',
  GRIDCOLUMNS_database_oracleInstanceDetail_sqlList:
    'GRIDCOLUMNS_database_oracleInstanceDetail_sqlList',
  GRIDCOLUMNS_database_instanceDetail_waitClass: 'GRIDCOLUMNS_database_instanceDetail_waitClass',
  GRIDCOLUMNS_database_instanceDetail_waitEvent: 'GRIDCOLUMNS_database_instanceDetail_waitEvent',
  GRIDCOLUMNS_database_instanceDetail_waitSqlList:
    'GRIDCOLUMNS_database_instanceDetail_waitSqlList',
  GRIDCOLUMNS_database_oracleInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_oracleInstanceDetail_parameterList',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_oracle_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_oracle_activeSessionList',
  FILTERSEARCH_database_instanceDetail_sessionManagerTab_oracle_sessionManagerList:
    'FILTERSEARCH_database_instanceDetail_sessionManagerTab_oracle_sessionManagerList',
  FILTERSEARCH_database_instanceDetail_lockInfoTab_oracle_lockSessionList:
    'FILTERSEARCH_database_instanceDetail_lockInfoTab_oracle_lockSessionList',
  FILTERSEARCH_database_instanceDetail_sqlListTab_oracle_sqlList:
    'FILTERSEARCH_database_instanceDetail_sqlListTab_oracle_sqlList',
  FILTERSEARCH_database_instanceDetail_eventTab_eventGrid:
    'FILTERSEARCH_database_instanceDetail_eventTab_eventGrid',
  FILTERSEARCH_database_instanceDetail_eventTab_sqlGrid:
    'FILTERSEARCH_database_instanceDetail_eventTab_sqlGrid',
  FILTERSEARCH_database_instanceDetail_parameterListTab_oracle_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterListTab_oracle_parameterList',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_oracle_parameterList:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_oracle_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterDetail_oracle_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_oracle_parameterList',

  // session detail
  GRIDCOLUMNS_database_oracleSessionDetail_activeSessionHistory:
    'GRIDCOLUMNS_database_oracleSessionDetail_activeSessionHistory',
  GRIDCOLUMNS_database_oracleSessionDetail_plan: 'GRIDCOLUMNS_database_oracleSessionDetail_plan',
  FILTERSEARCH_database_sessionDetail_oracle_sessionHistoryList:
    'FILTERSEARCH_database_sessionDetail_oracle_sessionHistoryList',
  TAB_database_oracleSessionDetail_selected: 'TAB_database_oracleSessionDetail_selected',

  // sql detail
  GRIDCOLUMNS_database_oracleSqlDetail_plan: 'GRIDCOLUMNS_database_oracleSqlDetail_plan',
  GRIDCOLUMNS_database_oracleSqlDetail_sqlHistory:
    'GRIDCOLUMNS_database_oracleSqlDetail_sqlHistory',
  FILTERSEARCH_database_oracleSqlDetail_sqlHistory:
    'FILTERSEARCH_database_oracleSqlDetail_sqlHistory',

  // multiView
  GRIDCOLUMNS_database_oracleMultiview_sessionTab_sessions:
    'GRIDCOLUMNS_database_oracleMultiview_sessionTab_sessions',
  GRIDCOLUMNS_database_oracleMultiview_sessionTab_waitChains:
    'GRIDCOLUMNS_database_oracleMultiview_sessionTab_waitChains',
  GRIDCOLUMNS_database_oracleMultiview_sessionTab_waitClass:
    'GRIDCOLUMNS_database_oracleMultiview_sessionTab_waitClass',
  GRIDCOLUMNS_database_oracleMultiview_sessionTab_waitEvent:
    'GRIDCOLUMNS_database_oracleMultiview_sessionTab_waitEvent',
  GRIDCOLUMNS_database_oracleMultiview_sessionTab_sqlSummary:
    'GRIDCOLUMNS_database_oracleMultiview_sessionTab_sqlSummary',
  FILTERSEARCH_database_oracleMultiview_sessionTab_sessions:
    'FILTERSEARCH_database_oracleMultiview_sessionTab_sessions',
  FILTERSEARCH_database_oracleMultiview_sessionTab_waitChains:
    'FILTERSEARCH_database_oracleMultiview_sessionTab_waitChains',
  FILTERSEARCH_database_oracleMultiview_sessionTab_waitClass:
    'FILTERSEARCH_database_oracleMultiview_sessionTab_waitClass',
  FILTERSEARCH_database_oracleMultiview_sessionTab_waitEvent:
    'FILTERSEARCH_database_oracleMultiview_sessionTab_waitEvent',
  FILTERSEARCH_database_oracleMultiview_sessionTab_sqlSummary:
    'FILTERSEARCH_database_oracleMultiview_sessionTab_sqlSummary',
  FILTERSEARCH_database_oracleMultiview_sessionTab_event:
    'FILTERSEARCH_database_oracleMultiview_sessionTab_event',

  // rtm session detail
  GRIDCOLUMNS_database_oracleRtm_sessionDetail_plan:
    'GRIDCOLUMNS_database_oracleRtm_sessionDetail_plan',

  METRIC_database_instanceView_instanceDetail_oracle_metricChart:
    'METRIC_database_instanceView_instanceDetail_oracle_metricChart',
  METRIC_database_instanceView_instanceDetail_oracle_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_oracle_metricChart_timePeriod',

  ORACLE_METRIC_CHART_METRIC_NAMES: 'ORACLE_METRIC_CHART_METRIC_NAMES',

  SELECT_database_oracleRtm_sessionTab_instanceId:
    'SELECT_database_oracleRtm_sessionTab_instanceId',
};

const POSTGRESQL_ENVS = {
  POSTGRESQL_SINGLE_VIEW_SELECTED_ID: 'POSTGRESQL_SINGLE_VIEW_SELECTED_ID',
  POSTGRESQL_MULTI_VIEW_SELECTED_ID: 'POSTGRESQL_MULTI_VIEW_SELECTED_ID',
  POSTGRESQL_MULTI_VIEW_SLOW_QUERY_OPTION: 'PG_MULTI_VIEW_SLOW_QUERY_OPTION',
  POSTGRESQL_METRIC_CHART_METRIC_NAMES: 'PG_METRIC_CHART_METRIC_NAMES',
  POSTGRESQL_MULTI_VIEW_OVERVIEW_METRIC_NAMES: 'PG_OVERVIEW_METRIC_NAMES',
  POSTGRESQL_SINGLE_VIEW_TOP_SQL_ORDER: 'PG_TOP_SQL_ORDER_BY',
  POSTGRESQL_SINGLE_VIEW_TOP_FUNCTION_ORDER: 'PG_TOP_FUNCTION_ORDER_BY',
  POSTGRESQL_SINGLE_VIEW_TREND_SUMMARY_METRIC_NAMES:
    'POSTGRESQL_SINGLE_VIEW_TREND_SUMMARY_METRIC_NAMES',
  POSTGRESQL_SINGLE_VIEW_SLOW_QUERY_OPTION: 'PG_SINGLE_VIEW_SLOW_QUERY_OPTION',

  // instance detail
  GRIDCOLUMNS_database_postgresqlInstanceDetail_databaseList:
    'GRIDCOLUMNS_database_postgresqlInstanceDetail_databaseList',
  GRIDCOLUMNS_database_postgresqlInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_postgresqlInstanceDetail_activeSession',
  GRIDCOLUMNS_database_postgresqlInstanceDetail_lockInfo:
    'GRIDCOLUMNS_database_postgresqlInstanceDetail_lockInfo',
  GRIDCOLUMNS_database_postgresqlInstanceDetail_sqlList:
    'GRIDCOLUMNS_database_postgresqlInstanceDetail_sqlList',
  GRIDCOLUMNS_database_postgresqlInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_postgresqlInstanceDetail_parameterList',
  GRIDCOLUMNS_database_postgresqlInstanceDetail_haTab_primaryStatus:
    'GRIDCOLUMNS_database_postgresqlInstanceDetail_haTab_primaryStatus',
  GRIDCOLUMNS_database_postgresqlInstanceDetail_haTab_replicaStatus:
    'GRIDCOLUMNS_database_postgresqlInstanceDetail_haTab_replicaStatus',

  FILTERSEARCH_database_postgresqlInstanceDetail_databaseList:
    'FILTERSEARCH_database_postgresqlInstanceDetail_databaseList',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_pg_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_pg_activeSessionList',
  FILTERSEARCH_database_instanceDetail_lockInfoTab_pg_lockSessionList:
    'FILTERSEARCH_database_instanceDetail_lockInfoTab_pg_lockSessionList',
  FILTERSEARCH_database_instanceDetail_sqlListTab_pg_sqlList:
    'FILTERSEARCH_database_instanceDetail_sqlListTab_pg_sqlList',
  FILTERSEARCH_database_instanceDetail_parameterListTab_pg_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterListTab_pg_parameterList',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_pg_parameterList:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_pg_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterDetail_pg_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_pg_parameterList',

  // session detail
  GRIDCOLUMNS_database_postgresqlSessionDetail_activeSessionHistory:
    'GRIDCOLUMNS_database_postgresqlSessionDetail_activeSessionHistory',
  GRIDCOLUMNS_database_postgresqlSessionDetail_plan:
    'GRIDCOLUMNS_database_postgresqlSessionDetail_plan',
  FILTERSEARCH_database_sessionDetail_pg_sessionHistoryList:
    'FILTERSEARCH_database_sessionDetail_pg_sessionHistoryList',
  TAB_database_postgresqlSessionDetail_selected: 'TAB_database_postgresqlSessionDetail_selected',

  // sql detail
  GRIDCOLUMNS_database_postgresqlSqlDetail_plan: 'GRIDCOLUMNS_database_postgresqlSqlDetail_plan',
  GRIDCOLUMNS_database_postgresqlSqlDetail_sqlHistory:
    'GRIDCOLUMNS_database_postgresqlSqlDetail_sqlHistory',
  FILTERSEARCH_database_postgresqlSqlDetail_sqlHistory:
    'FILTERSEARCH_database_postgresqlSqlDetail_sqlHistory',

  // singleView, multiView
  GRIDCOLUMNS_database_postgresqlRtm_topObjectWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_topObjectWindow',
  GRIDCOLUMNS_database_postgresqlRtm_topSqlWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_topSqlWindow',
  GRIDCOLUMNS_database_postgresqlRtm_fileUsageWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_fileUsageWindow',
  GRIDCOLUMNS_database_postgresqlRtm_sessionDetail_plan:
    'GRIDCOLUMNS_database_postgresqlRtm_sessionDetail_plan',
  GRIDCOLUMNS_database_postgresqlRtm_lockTree: 'GRIDCOLUMNS_database_postgresqlRtm_lockTree',
  GRIDCOLUMNS_database_postgresqlRtm_activeBackends:
    'GRIDCOLUMNS_database_postgresqlRtm_activeBackends',
  GRIDCOLUMNS_database_postgresqlRtm_vacuumingBackendsWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_vacuumingBackendsWindow',
  GRIDCOLUMNS_database_postgresqlRtm_parameterWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_parameterWindow',
  GRIDCOLUMNS_database_postgresqlRtm_topObjectTablespaceWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_topObjectTablespaceWindow',
  GRIDCOLUMNS_database_postgresqlRtm_oldStatisticsWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_oldStatisticsWindow',
  GRIDCOLUMNS_database_postgresqlRtm_slowQueryWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_slowQueryWindow',
  GRIDCOLUMNS_database_postgresqlRtm_sqlElapsedWindow:
    'GRIDCOLUMNS_database_postgresqlRtm_sqlElapsedWindow',
  GRIDCOLUMNS_database_postgresqlRtm_rank: 'GRIDCOLUMNS_database_postgresqlRtm_rank',

  FILTERSEARCH_database_postgresqlRtm_lockTree: 'FILTERSEARCH_database_postgresqlRtm_lockTree',
  FILTERSEARCH_database_postgresqlRtm_activeBackends:
    'FILTERSEARCH_database_postgresqlRtm_activeBackends',
  FILTERSEARCH_database_postgresqlRtm_vacuumingBackendsWindow:
    'FILTERSEARCH_database_postgresqlRtm_vacuumingBackendsWindow',
  FILTERSEARCH_database_postgresqlRtm_slowQueryWindow:
    'FILTERSEARCH_database_postgresqlRtm_slowQueryWindow',
  FILTERSEARCH_database_postgresqlRtm_topObjectWindow:
    'FILTERSEARCH_database_postgresqlRtm_topObjectWindow',
  FILTERSEARCH_database_postgresqlRtm_fileUsageWindow:
    'FILTERSEARCH_database_postgresqlRtm_fileUsageWindow',
  FILTERSEARCH_database_postgresqlRtm_parameterWindow:
    'FILTERSEARCH_database_postgresqlRtm_parameterWindow',
  FILTERSEARCH_database_postgresqlRtm_topObjectTablespaceWindow:
    'FILTERSEARCH_database_postgresqlRtm_topObjectTablespaceWindow',
  FILTERSEARCH_database_postgresqlRtm_topSqlWindow:
    'FILTERSEARCH_database_postgresqlRtm_topSqlWindow',
  FILTERSEARCH_database_postgresqlRtm_oldStatisticsWindow:
    'FILTERSEARCH_database_postgresqlRtm_oldStatisticsWindow',
  FILTERSEARCH_database_postgresqlRtm_sqlElapsedWindow:
    'FILTERSEARCH_database_postgresqlRtm_sqlElapsedWindow',

  LASTSELECTED_database_postgresqlRtm_dbId: 'LASTSELECTED_database_postgresqlRtm_dbId',

  SELECT_database_postgresqlRtm_sessionTab_instanceId:
    'SELECT_database_postgresqlRtm_sessionTab_instanceId',

  METRIC_database_instanceView_instanceDetail_postaresql_metricChart:
    'METRIC_database_instanceView_instanceDetail_postaresql_metricChart',
  METRIC_database_instanceView_instanceDetail_postgresql_database_metricChart:
    'METRIC_database_instanceView_instanceDetail_postgresql_database_metricChart',

  METRIC_database_instanceView_instanceDetail_postaresql_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_postaresql_metricChart_timePeriod',
};

const MYSQL_ENVS = {
  MYSQL_SINGLE_VIEW_SELECTED_ID: 'MYSQL_SINGLE_VIEW_SELECTED_ID',
  MYSQL_MULTI_VIEW_SELECTED_ID: 'MYSQL_MULTI_VIEW_SELECTED_ID',
  MYSQL_MULTI_VIEW_SLOW_QUERY_OPTION: 'MYSQL_MULTI_VIEW_SLOW_QUERY_OPTION',
  MYSQL_METRIC_CHART_METRIC_NAMES: 'MYSQL_METRIC_CHART_METRIC_NAMES',
  MYSQL_MULTI_VIEW_OVERVIEW_METRIC_NAMES: 'MYSQL_OVERVIEW_METRIC_NAMES',
  MYSQL_SINGLE_VIEW_TOP_SQL_ORDER: 'MYSQL_TOP_SQL_ORDER_BY',
  MYSQL_SINGLE_VIEW_TOP_SQL_QUERY_ERROR_ORDER: 'MYSQL_TOP_SQL_QUERY_ERROR_ORDER_BY',
  MYSQL_SINGLE_VIEW_TREND_SUMMARY_METRIC_NAMES: 'MYSQL_TREND_SUMMARY_METRIC_NAMES',
  MYSQL_SINGLE_VIEW_SLOW_QUERY_OPTION: 'MYSQL_SINGLE_VIEW_SLOW_QUERY_OPTION',
  MYSQL_SINGLE_VIEW_STAT_INFO: 'MYSQL_STAT_INFO',

  // instance detail
  GRIDCOLUMNS_database_mysqlInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_mysqlInstanceDetail_activeSession',
  GRIDCOLUMNS_database_mysqlInstanceDetail_processList:
    'GRIDCOLUMNS_database_mysqlInstanceDetail_processList',
  GRIDCOLUMNS_database_mysqlInstanceDetail_lockInfo:
    'GRIDCOLUMNS_database_mysqlInstanceDetail_lockInfo',
  GRIDCOLUMNS_database_mysqlInstanceDetail_sqlList:
    'GRIDCOLUMNS_database_mysqlInstanceDetail_sqlList',
  GRIDCOLUMNS_database_mysqlInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_mysqlInstanceDetail_parameterList',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_mysql_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_mysql_activeSessionList',
  FILTERSEARCH_database_instanceDetail_processListTab_mysql_processList:
    'FILTERSEARCH_database_instanceDetail_processListTab_mysql_processList',
  FILTERSEARCH_database_instanceDetail_lockInfoTab_mysql_lockSessionList:
    'FILTERSEARCH_database_instanceDetail_lockInfoTab_mysql_lockSessionList',
  FILTERSEARCH_database_instanceDetail_sqlListTab_mysql_sqlList:
    'FILTERSEARCH_database_instanceDetail_sqlListTab_mysql_sqlList',
  FILTERSEARCH_database_instanceDetail_parameterListTab_mysql_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterListTab_mysql_parameterList',
  FILTERSEARCH_database_instanceDetail_cloudEventTab_alarmLogList:
    'FILTERSEARCH_database_instanceDetail_cloudEventTab_alarmLogList',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_mysql_parameterList:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_mysql_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterDetail_mysql_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_mysql_parameterList',

  // session detail
  GRIDCOLUMNS_database_mysqlSessionDetail_activeSessionHistory:
    'GRIDCOLUMNS_database_mysqlSessionDetail_activeSessionHistory',
  GRIDCOLUMNS_database_mysqlSessionDetail_plan: 'GRIDCOLUMNS_database_mysqlSessionDetail_plan',
  FILTERSEARCH_database_sessionDetail_mysql_sessionHistoryList:
    'FILTERSEARCH_database_sessionDetail_mysql_sessionHistoryList',
  TAB_database_mysqlSessionDetail_selected: 'TAB_database_mysqlSessionDetail_selected',

  // sql detail
  GRIDCOLUMNS_database_mysqlSqlDetail_plan: 'GRIDCOLUMNS_database_mysqlSqlDetail_plan',
  GRIDCOLUMNS_database_mysqlSqlDetail_sqlHistory: 'GRIDCOLUMNS_database_mysqlSqlDetail_sqlHistory',
  FILTERSEARCH_database_mysqlSqlDetail_sqlHistory:
    'FILTERSEARCH_database_mysqlSqlDetail_sqlHistory',

  // singleView, multiView
  GRIDCOLUMNS_database_mysqlRtm_topObjectWindow: 'GRIDCOLUMNS_database_mysqlRtm_topObjectWindow',
  GRIDCOLUMNS_database_mysqlRtm_globalTempWindow: 'GRIDCOLUMNS_database_mysqlRtm_globalTempWindow',
  GRIDCOLUMNS_database_mysqlRtm_sessionTempWindow:
    'GRIDCOLUMNS_database_mysqlRtm_sessionTempWindow',
  GRIDCOLUMNS_database_mysqlRtm_topSqlWindow: 'GRIDCOLUMNS_database_mysqlRtm_topSqlWindow',
  GRIDCOLUMNS_database_mysqlRtm_topTransactionWindow:
    'GRIDCOLUMNS_database_mysqlRtm_topTransactionWindow',
  GRIDCOLUMNS_database_mysqlRtm_slowQueryWindow_plan:
    'GRIDCOLUMNS_database_mysqlRtm_slowQueryWindow_plan',
  GRIDCOLUMNS_database_mysqlRtm_thread: 'GRIDCOLUMNS_database_mysqlRtm_thread',
  GRIDCOLUMNS_database_mysqlRtm_processList: 'GRIDCOLUMNS_database_mysqlRtm_processList',
  GRIDCOLUMNS_database_mysqlRtm_lockTree: 'GRIDCOLUMNS_database_mysqlRtm_lockTree',
  GRIDCOLUMNS_database_mysqlRtm_metaLockTree: 'GRIDCOLUMNS_database_mysqlRtm_metaLockTree',
  GRIDCOLUMNS_database_mysqlRtm_rank: 'GRIDCOLUMNS_database_mysqlRtm_rank',
  GRIDCOLUMNS_database_mysql_sessionDetailWindow_plan:
    'GRIDCOLUMNS_database_mysql_sessionDetailWindow_plan',
  GRIDCOLUMNS_database_mysqlRtm_topEventWindow: 'GRIDCOLUMNS_database_mysqlRtm_topEventWindow',
  GRIDCOLUMNS_database_mysqlRtm_topSqlErrorWindow:
    'GRIDCOLUMNS_database_mysqlRtm_topSqlErrorWindow',
  GRIDCOLUMNS_database_mysqlRtm_topFullScanWindow:
    'GRIDCOLUMNS_database_mysqlRtm_topFullScanWindow',
  GRIDCOLUMNS_database_mysqlRtm_parameterWindow: 'GRIDCOLUMNS_database_mysqlRtm_parameterWindow',
  GRIDCOLUMNS_database_mysqlRtm_topTablespaceWindow:
    'GRIDCOLUMNS_database_mysqlRtm_topTablespaceWindow',
  GRIDCOLUMNS_database_mysqlRtm_slowQueryWindow: 'GRIDCOLUMNS_database_mysqlRtm_slowQueryWindow',
  GRIDCOLUMNS_database_mysqlRtm_sqlElapsedWindow: 'GRIDCOLUMNS_database_mysqlRtm_sqlElapsedWindow',
  FILTERSEARCH_database_mysqlRtm_thread: 'FILTERSEARCH_database_mysqlRtm_thread',
  FILTERSEARCH_database_mysqlRtm_processList: 'FILTERSEARCH_database_mysqlRtm_processList',
  FILTERSEARCH_database_mysqlRtm_lockTree: 'FILTERSEARCH_database_mysqlRtm_lockTree',
  FILTERSEARCH_database_mysqlRtm_metaLockTree: 'FILTERSEARCH_database_mysqlRtm_metaLockTree',

  SELECT_database_mysqlRtm_sessionTab_instanceId: 'SELECT_database_mysqlRtm_sessionTab_instanceId',

  METRIC_database_instanceView_instanceDetail_mysql_metricChart:
    'METRIC_database_instanceView_instanceDetail_mysql_metricChart',
  METRIC_database_instanceView_instanceDetail_mysql_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_mysql_metricChart_timePeriod',
};

const SQLSERVER_ENVS = {
  SQLSERVER_SINGLE_VIEW_SELECTED_ID: 'SQLSERVER_SINGLE_VIEW_SELECTED_ID',

  // instance detail
  GRIDCOLUMNS_database_sqlserverInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_sqlserverInstanceDetail_activeSession',
  GRIDCOLUMNS_database_sqlserverInstanceDetail_sqlList:
    'GRIDCOLUMNS_database_sqlserverInstanceDetail_sqlList',
  GRIDCOLUMNS_database_sqlserverInstanceDetail_lockInfo:
    'GRIDCOLUMNS_database_sqlserverInstanceDetail_lockInfo',
  GRIDCOLUMNS_database_sqlserverInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_sqlserverInstanceDetail_parameterList',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_sqlserver_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_sqlserver_activeSessionList',
  FILTERSEARCH_database_instanceDetail_lockInfoTab_sqlserver_lockSessionList:
    'FILTERSEARCH_database_instanceDetail_lockInfoTab_sqlserver_lockSessionList',
  FILTERSEARCH_database_instanceDetail_sqlListTab_sqlserver_sqlList:
    'FILTERSEARCH_database_instanceDetail_sqlListTab_sqlserver_sqlList',
  FILTERSEARCH_database_instanceDetail_parameterListTab_sqlserver_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterListTab_sqlserver_parameterList',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_sqlserver_parameterList:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_sqlserver_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterDetail_sqlserver_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_sqlserver_parameterList',

  // session detail
  GRIDCOLUMNS_database_sqlserverSessionDetail_activeSessionHistory:
    'GRIDCOLUMNS_database_sqlserverSessionDetail_activeSessionHistory',
  GRIDCOLUMNS_database_sqlserverSessionDetail_plan:
    'GRIDCOLUMNS_database_sqlserverSessionDetail_plan',
  FILTERSEARCH_database_sessionDetail_sqlserver_sessionHistoryList:
    'FILTERSEARCH_database_sessionDetail_sqlserver_sessionHistoryList',
  TAB_database_sqlserverSessionDetail_selected: 'TAB_database_sqlserverSessionDetail_selected',

  // sql detail
  GRIDCOLUMNS_database_sqlserverSqlDetail_plan: 'GRIDCOLUMNS_database_sqlserverSqlDetail_plan',
  GRIDCOLUMNS_database_sqlserverSqlDetail_sqlHistory:
    'GRIDCOLUMNS_database_sqlserverSqlDetail_sqlHistory',
  GRIDCOLUMNS_database_sqlserverSqlDetail_parameterList:
    'GRIDCOLUMNS_database_sqlserverSqlDetail_parameterList',

  FILTERSEARCH_database_sqlserverSqlDetail_sqlHistory:
    'FILTERSEARCH_database_sqlserverSqlDetail_sqlHistory',
  FILTERSEARCH_database_sqlserverSqlDetail_parameterList:
    'FILTERSEARCH_database_sqlserverSqlDetail_parameterList',

  // singleView
  GRIDCOLUMNS_database_sqlserverRtm_sessionListWindow:
    'GRIDCOLUMNS_database_sqlserverRtm_sessionListWindow',
  GRIDCOLUMNS_database_sqlserverRtm_sqlStatWindow:
    'GRIDCOLUMNS_database_sqlserverRtm_sqlStatWindow',
  GRIDCOLUMNS_database_sqlserverRtm_sessionTab_session:
    'GRIDCOLUMNS_database_sqlserverRtm_sessionTab_session',
  GRIDCOLUMNS_database_sqlserverRtm_sessionTab_blocked:
    'GRIDCOLUMNS_database_sqlserverRtm_sessionTab_blocked',
  GRIDCOLUMNS_database_sqlserverRtm_sessionManager_session:
    'GRIDCOLUMNS_database_sqlserverRtm_sessionManager_session',
  GRIDCOLUMNS_database_sqlserverRtm_sessionManager_blocked:
    'GRIDCOLUMNS_database_sqlserverRtm_sessionManager_blocked',
  GRIDCOLUMNS_database_sqlserverRtm_session: 'GRIDCOLUMNS_database_sqlserverRtm_session',
  GRIDCOLUMNS_database_sqlserverRtm_blocked: 'GRIDCOLUMNS_database_sqlserverRtm_blocked',
  FILTERSEARCH_database_sqlserverRtm_sessionTab_session:
    'FILTERSEARCH_database_sqlserverRtm_sessionTab_session',
  FILTERSEARCH_database_sqlserverRtm_sessionTab_blocked:
    'FILTERSEARCH_database_sqlserverRtm_sessionTab_blocked',

  METRIC_database_instanceView_instanceDetail_sqlserver_metricChart:
    'METRIC_database_instanceView_instanceDetail_sqlserver_metricChart',
  METRIC_database_instanceView_instanceDetail_sqlserver_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_sqlserver_metricChart_timePeriod',

  SQLSERVER_TREND_CHART_METRIC_NAMES: 'SQLSERVER_TREND_CHART_METRIC_NAMES',
  SQLSERVER_METRIC_CHART_METRIC_NAMES: 'SQLSERVER_METRIC_CHART_METRIC_NAMES',
};

const CUBRID_ENVS = {
  // instance detail
  GRIDCOLUMNS_database_cubridInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_cubridInstanceDetail_activeSession',
  GRIDCOLUMNS_database_cubridInstanceDetail_lockInfo:
    'GRIDCOLUMNS_database_cubridInstanceDetail_lockInfo',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_cubrid_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_cubrid_activeSessionList',
  FILTERSEARCH_database_instanceDetail_lockInfoTab_cubrid_lockSessionList:
    'FILTERSEARCH_database_instanceDetail_lockInfoTab_cubrid_lockSessionList',

  // broker detail
  GRIDCOLUMNS_database_cubrid_broker_activeCasList:
    'GRIDCOLUMNS_database_cubrid_broker_activeCasList',

  METRIC_database_instanceView_instanceDetail_cubrid_metricChart:
    'METRIC_database_instanceView_instanceDetail_cubrid_metricChart',
  METRIC_database_instanceView_instanceDetail_cubrid_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_cubrid_metricChart_timePeriod',
  METRIC_database_cubrid_brokerDetail_metricChart_timePeriod:
    'METRIC_database_cubrid_brokerDetail_metricChart_timePeriod',
};

const MONGO_ENVS = {
  // instance detail
  GRIDCOLUMNS_database_mongodbInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_mongodbInstanceDetail_activeSession',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_mongo_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_mongo_activeSessionList',

  // mongos
  GRIDCOLUMNS_database_mongos_clusterMap: 'GRIDCOLUMNS_database_mongos_clusterMap',

  METRIC_database_instanceView_instanceDetail_mongodb_metricChart:
    'METRIC_database_instanceView_instanceDetail_mongodb_metricChart',
  METRIC_database_instanceView_instanceDetail_mongodb_mongos_metricChart:
    'METRIC_database_instanceView_instanceDetail_mongodb_mongos_metricChart',

  METRIC_database_instanceView_instanceDetail_mongodb_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_mongodb_metricChart_timePeriod',
  METRIC_database_instanceView_instanceDetail_mongodb_mongos_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_mongodb_mongos_metricChart_timePeriod',
};

const REDIS_ENVS = {
  // redis key browser
  GRIDCOLUMNS_database_instanceDetail_keyBrowser_list:
    'GRIDCOLUMNS_database_instanceDetail_keyBrowser_list',
  GRIDCOLUMNS_database_instanceDetail_keyBrowser_set:
    'GRIDCOLUMNS_database_instanceDetail_keyBrowser_set',
  GRIDCOLUMNS_database_instanceDetail_keyBrowser_sortedSet:
    'GRIDCOLUMNS_database_instanceDetail_keyBrowser_sortedSet',
  GRIDCOLUMNS_database_instanceDetail_keyBrowser_streamData:
    'GRIDCOLUMNS_database_instanceDetail_keyBrowser_streamData',
  GRIDCOLUMNS_database_instanceDetail_keyBrowser_streamConsumerGroups:
    'GRIDCOLUMNS_database_instanceDetail_keyBrowser_streamConsumerGroups',
  GRIDCOLUMNS_database_instanceDetail_keyBrowser_hash:
    'GRIDCOLUMNS_database_instanceDetail_keyBrowser_hash',
  FILTERSEARCH_database_instanceDetail_keyBrowser_list:
    'FILTERSEARCH_database_instanceDetail_keyBrowser_list',
  FILTERSEARCH_database_instanceDetail_keyBrowser_set:
    'FILTERSEARCH_database_instanceDetail_keyBrowser_set',
  FILTERSEARCH_database_instanceDetail_keyBrowser_sortedSet:
    'FILTERSEARCH_database_instanceDetail_keyBrowser_sortedSet',
  FILTERSEARCH_database_instanceDetail_keyBrowser_streamData:
    'FILTERSEARCH_database_instanceDetail_keyBrowser_streamData',
  FILTERSEARCH_database_instanceDetail_keyBrowser_streamConsumerGroups:
    'FILTERSEARCH_database_instanceDetail_keyBrowser_streamConsumerGroups',
  FILTERSEARCH_database_instanceDetail_keyBrowser_hash:
    'FILTERSEARCH_database_instanceDetail_keyBrowser_hash',
  FILTERSEARCH_database_instanceDetail_keyBrowser:
    'FILTERSEARCH_database_instanceDetail_keyBrowser',
  FILTERSEARCH_database_instanceDetail_keyBrowserScanMatch:
    'FILTERSEARCH_database_instanceDetail_keyBrowserScanMatch',
  SELECT_database_instanceDetail_keyBrowser_string:
    'SELECT_database_instanceDetail_keyBrowser_string',

  METRIC_database_instanceView_instanceDetail_redis_metricChart:
    'METRIC_database_instanceView_instanceDetail_redis_metricChart',
  METRIC_database_instanceView_instanceDetail_redis_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_redis_metricChart_timePeriod',
};

const ALTIBASE_ENVS = {
  ALTIBASE_MULTI_VIEW_SELECTED_ID: 'ALTIBASE_MULTI_VIEW_SELECTED_ID',

  // instance detail
  GRIDCOLUMNS_database_altibaseInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_altibaseInstanceDetail_activeSession',
  GRIDCOLUMNS_database_altibaseInstanceDetail_lockInfo:
    'GRIDCOLUMNS_database_altibaseInstanceDetail_lockInfo',
  GRIDCOLUMNS_database_altibaseInstanceDetail_sqlList:
    'GRIDCOLUMNS_database_altibaseInstanceDetail_sqlList',
  GRIDCOLUMNS_database_altibaseInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_altibaseInstanceDetail_parameterList',
  GRIDCOLUMNS_database_altibaseInstanceDetail_memoryTableList:
    'GRIDCOLUMNS_database_altibaseInstanceDetail_memoryTableList',
  GRIDCOLUMNS_database_altibaseInstanceDetail_memoryModuleList:
    'GRIDCOLUMNS_database_altibaseInstanceDetail_memoryModuleList',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_altibase_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_altibase_activeSessionList',
  FILTERSEARCH_database_instanceDetail_lockInfoTab_altibase_lockSessionList:
    'FILTERSEARCH_database_instanceDetail_lockInfoTab_altibase_lockSessionList',
  FILTERSEARCH_database_instanceDetail_sqlListTab_altibase_sqlList:
    'FILTERSEARCH_database_instanceDetail_sqlListTab_altibase_sqlList',
  FILTERSEARCH_database_instanceDetail_parameterListTab_altibase_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterListTab_altibase_parameterList',
  FILTERSEARCH_database_altibaseInstanceDetail_memoryTableList:
    'FILTERSEARCH_database_altibaseInstanceDetail_memoryTableList',
  FILTERSEARCH_database_altibaseInstanceDetail_memoryModuleList:
    'FILTERSEARCH_database_altibaseInstanceDetail_memoryModuleList',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_altibase_parameterList:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_altibase_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterDetail_altibase_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_altibase_parameterList',

  // session detail
  GRIDCOLUMNS_database_altibaseSessionDetail_activeSessionHistory:
    'GRIDCOLUMNS_database_altibaseSessionDetail_activeSessionHistory',
  GRIDCOLUMNS_database_altibaseSessionDetail_plan:
    'GRIDCOLUMNS_database_altibaseSessionDetail_plan',
  FILTERSEARCH_database_sessionDetail_altibase_sessionHistoryList:
    'FILTERSEARCH_database_sessionDetail_altibase_sessionHistoryList',
  TAB_database_altibaseSessionDetail_selected: 'TAB_database_altibaseSessionDetail_selected',

  // sql detail
  GRIDCOLUMNS_database_altibaseSqlDetail_plan: 'GRIDCOLUMNS_database_altibaseSqlDetail_plan',
  GRIDCOLUMNS_database_altibaseSqlDetail_sqlHistory:
    'GRIDCOLUMNS_database_altibaseSqlDetail_sqlHistory',
  FILTERSEARCH_database_altibaseSqlDetail_plan: 'FILTERSEARCH_database_altibaseSqlDetail_plan',
  FILTERSEARCH_database_altibaseSqlDetail_sqlHistory:
    'FILTERSEARCH_database_altibaseSqlDetail_sqlHistory',

  METRIC_database_instanceView_instanceDetail_altibase_metricChart:
    'METRIC_database_instanceView_instanceDetail_altibase_metricChart',
  METRIC_database_instanceView_instanceDetail_altibase_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_altibase_metricChart_timePeriod',

  // replication detail
  METRIC_database_instanceView_instanceReplicationDetail_replication_metricChart:
    'METRIC_database_instanceView_instanceReplicationDetail_replication_metricChart',
  METRIC_database_instanceView_instanceReplicationDetail_replication_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceReplicationDetail_replication_metricChart_timePeriod',

  // Altibase Multi View
  // Tablespace Usage Window
  USAGE_database_altibase_tablespaceUsageWindow_usage:
    'USAGE_database_altibase_tablespaceUsageWindow_usage',
  GRIDCOLUMNS_database_altibase_tablespaceUsageWindow_usage:
    'GRIDCOLUMNS_database_altibase_tablespaceUsageWindow_usage',
  GRIDCOLUMNS_database_altibase_tablespaceUsageWindow_topMemoryTable:
    'GRIDCOLUMNS_database_altibase_tablespaceUsageWindow_topMemoryTable',
  GRIDCOLUMNS_database_altibase_tablespaceUsageWindow_topDiskSegment:
    'GRIDCOLUMNS_database_altibase_tablespaceUsageWindow_topDiskSegment',

  // Top 10 Session Undo/Temp List Window
  GRIDCOLUMNS__database_altibase_top10SessionUndoList:
    'GRIDCOLUMNS__database_altibase_top10SessionUndoList',
  GRIDCOLUMNS__database_altibase_top10SessionTempList:
    'GRIDCOLUMNS__database_altibase_top10SessionTempList',

  // Top 10 Full Scan Query Window
  GRIDCOLUMNS_database_altibase_top10FullScanQueryWindow_top10Sql:
    'GRIDCOLUMNS_database_altibase_top10FullScanQueryWindow_top10Sql',

  // sqlElapsedList window
  GRIDCOLUMNS_database_altibaseSqlElapsedListWindow:
    'GRIDCOLUMNS_database_altibaseSqlElapsedListWindow',
  FILTERSEARCH_database_altibaseSqlElapsedListWindow:
    'FILTERSEARCH_database_altibaseSqlElapsedListWindow',

  // replication detail window
  GRIDCOLUMNS_database_altibaseReplicationDetailWindow_objectList:
    'GRIDCOLUMNS_database_altibaseReplicationDetailWindow_objectList',

  // multiView
  FILTERSEARCH_database_sessionTable_session: 'FILTERSEARCH_database_sessionTable_session',
  FILTERSEARCH_database_sessionTable_lock: 'FILTERSEARCH_database_sessionTable_lock',
  GRIDCOLUMNS_database_sessionTable_session: 'GRIDCOLUMNS_database_sessionTable_session',
  GRIDCOLUMNS_database_sessionTable_lock: 'GRIDCOLUMNS_database_sessionTable_lock',
  FILTERSEARCH_database_altibase_rankAlertLogs: 'FILTERSEARCH_database_altibase_rankAlertLogs',
  GRIDCOLUMNS_database_altibase_rankAlertLogs: 'GRIDCOLUMNS_database_altibase_rankAlertLogs',
  SCATTER_database_altibase: 'SCATTER_database_altibase',
  METRIC_multi_view_chart_altibase: 'METRIC_multi_view_chart_altibase',
  GRIDCOLUMNS_database_altibase_rankRatioChart: 'GRIDCOLUMNS_database_altibase_rankRatioChart',
};

const TIBERO_ENVS = {
  // instance detail
  GRIDCOLUMNS_database_tiberoInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_tiberoInstanceDetail_activeSession',
  GRIDCOLUMNS_database_tiberoInstanceDetail_lockInfo:
    'GRIDCOLUMNS_database_tiberoInstanceDetail_lockInfo',
  GRIDCOLUMNS_database_tiberoInstanceDetail_sqlList:
    'GRIDCOLUMNS_database_tiberoInstanceDetail_sqlList',
  GRIDCOLUMNS_database_tiberoInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_tiberoInstanceDetail_parameterList',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_tibero_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_tibero_activeSessionList',
  FILTERSEARCH_database_instanceDetail_lockInfoTab_tibero_lockSessionList:
    'FILTERSEARCH_database_instanceDetail_lockInfoTab_tibero_lockSessionList',
  FILTERSEARCH_database_instanceDetail_sqlListTab_tibero_sqlList:
    'FILTERSEARCH_database_instanceDetail_sqlListTab_tibero_sqlList',
  FILTERSEARCH_database_instanceDetail_parameterListTab_tibero_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterListTab_tibero_parameterList',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_tibero_parameterList:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_tibero_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterDetail_tibero_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_tibero_parameterList',

  // session detail
  GRIDCOLUMNS_database_tiberoSessionDetail_activeSessionHistory:
    'GRIDCOLUMNS_database_tiberoSessionDetail_activeSessionHistory',
  GRIDCOLUMNS_database_tiberoSessionDetail_plan: 'GRIDCOLUMNS_database_tiberoSessionDetail_plan',
  FILTERSEARCH_database_sessionDetail_tibero_sessionHistoryList:
    'FILTERSEARCH_database_sessionDetail_tibero_sessionHistoryList',
  TAB_database_tiberoSessionDetail_selected: 'TAB_database_tiberoSessionDetail_selected',

  // sql detail
  GRIDCOLUMNS_database_tiberoSqlDetail_plan: 'GRIDCOLUMNS_database_tiberoSqlDetail_plan',
  GRIDCOLUMNS_database_tiberoSqlDetail_sqlHistory:
    'GRIDCOLUMNS_database_tiberoSqlDetail_sqlHistory',
  FILTERSEARCH_database_tiberoSqlDetail_plan: 'FILTERSEARCH_database_tiberoSqlDetail_plan',
  FILTERSEARCH_database_tiberoSqlDetail_sqlHistory:
    'FILTERSEARCH_database_tiberoSqlDetail_sqlHistory',

  METRIC_database_instanceView_instanceDetail_tibero_metricChart:
    'METRIC_database_instanceView_instanceDetail_tibero_metricChart',
  METRIC_database_instanceView_instanceDetail_tibero_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_tibero_metricChart_timePeriod',
};

const CLICKHOUSE_ENVS = {
  GRIDCOLUMNS_database_clickhouseInstanceDetail_diskInfo:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_diskInfo',
  FILTERSEARCH_database_clickhouseInstanceDetail_diskInfo:
    'FILTERSEARCH_database_clickhouseInstanceDetail_diskInfo',

  GRIDCOLUMNS_database_clickhouseInstanceDetail_activeProcess:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_activeProcess',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_clickhouse_activeProcess:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_clickhouse_activeProcess',
  METRIC_database_instanceView_instanceDetail_clickhouse_metricChart:
    'METRIC_database_instanceView_instanceDetail_clickhouse_metricChart',
  METRIC_database_instanceView_instanceDetail_clickhouse_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_clickhouse_metricChart_timePeriod',
  GRIDCOLUMNS_database_clickhouseInstanceDetail_partLog:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_partLog',
  FILTERSEARCH_database_clickhouseInstanceDetail_partLog:
    'FILTERSEARCH_database_clickhouseInstanceDetail_partLog',
  GRIDCOLUMNS_database_clickhouseInstanceDetail_queryLog:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_queryLog',
  FILTERSEARCH_database_clickhouseInstanceDetail_queryLog:
    'FILTERSEARCH_database_clickhouseInstanceDetail_queryLog',
  GRIDCOLUMNS_database_clickhouseInstanceDetail_partActivity:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_partActivity',
  FILTERSEARCH_database_clickhouseInstanceDetail_partActivity:
    'FILTERSEARCH_database_clickhouseInstanceDetail_partActivity',
  GRIDCOLUMNS_database_clickhouseInstanceDetail_mergeEvent:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_mergeEvent',
  FILTERSEARCH_database_clickhouseInstanceDetail_mergeEvent:
    'FILTERSEARCH_database_clickhouseInstanceDetail_mergeEvent',
  GRIDCOLUMNS_database_clickhouseInstanceDetail_mutation:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_mutation',
  FILTERSEARCH_database_clickhouseInstanceDetail_mutation:
    'FILTERSEARCH_database_clickhouseInstanceDetail_mutation',
  GRIDCOLUMNS_database_clickhouseInstanceDetail_replication:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_replication',
  FILTERSEARCH_database_clickhouseInstanceDetail_replication:
    'FILTERSEARCH_database_clickhouseInstanceDetail_replication',
  GRIDCOLUMNS_database_clickhouseInstanceDetail_textLog:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_textLog',
  FILTERSEARCH_database_clickhouseInstanceDetail_textLog:
    'FILTERSEARCH_database_clickhouseInstanceDetail_textLog',
  GRIDCOLUMNS_database_clickhouseInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_clickhouseInstanceDetail_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterListTab_clickhouse_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterListTab_clickhouse_parameterList',

  // sql detail
  GRIDCOLUMNS_database_clickhouseSqlDetail_sqlHistory:
    'GRIDCOLUMNS_database_clickhouseSqlDetail_sqlHistory',
  FILTERSEARCH_database_clickhouseSqlDetail_sqlHistory:
    'FILTERSEARCH_database_clickhouseSqlDetail_sqlHistory',
  GRIDCOLUMNS_database_clickhouseSqlDetail_plan: 'GRIDCOLUMNS_database_clickhouseSqlDetail_plan',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_clickhouse_parameterList:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_clickhouse_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterDetail_clickhouse_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_clickhouse_parameterList',
};

const REDSHIFT_ENVS = {
  // instance detail
  METRIC_database_instanceView_instanceDetail_redshift_metricChart:
    'METRIC_database_instanceView_instanceDetail_redshift_metricChart',
  METRIC_database_instanceView_instanceDetail_redshift_metricChart_timePeriod:
    'METRIC_database_instanceView_instanceDetail_redshift_metricChart_timePeriod',
  GRIDCOLUMNS_database_redshiftInstanceDetail_activeSession:
    'GRIDCOLUMNS_database_redshiftInstanceDetail_activeSession',
  GRIDCOLUMNS_database_redshiftInstanceDetail_sqlList:
    'GRIDCOLUMNS_database_redshiftInstanceDetail_sqlList',
  GRIDCOLUMNS_database_redshiftInstanceDetail_lockInfo:
    'GRIDCOLUMNS_database_redshiftInstanceDetail_lockInfo',
  GRIDCOLUMNS_database_redshiftInstanceDetail_tableInfo:
    'GRIDCOLUMNS_database_redshiftInstanceDetail_tableInfo',
  GRIDCOLUMNS_database_redshiftInstanceDetail_userLog:
    'GRIDCOLUMNS_database_redshiftInstanceDetail_userLog',
  GRIDCOLUMNS_database_redshiftInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_redshiftInstanceDetail_parameterList',
  GRIDCOLUMNS_database_redshiftInstanceDetail_slowQuery:
    'GRIDCOLUMNS_database_redshiftInstanceDetail_slowQuery',
  FILTERSEARCH_database_instanceDetail_activeSessionTab_redshift_activeSessionList:
    'FILTERSEARCH_database_instanceDetail_activeSessionTab_redshift_activeSessionList',
  FILTERSEARCH_database_instanceDetail_sqlListTab_redshift_sqlList:
    'FILTERSEARCH_database_instanceDetail_sqlListTab_redshift_sqlList',
  FILTERSEARCH_database_instanceDetail_lockInfoTab_redshift_lockSessionList:
    'FILTERSEARCH_database_instanceDetail_lockInfoTab_redshift_lockSessionList',
  FILTERSEARCH_database_instanceDetail_tableInfoTab_redshift_tableInfo:
    'FILTERSEARCH_database_instanceDetail_tableInfoTab_redshift_tableInfo',
  FILTERSEARCH_database_instanceDetail_parameterListTab_redshift_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterListTab_redshift_parameterList',
  FILTERSEARCH_database_instanceDetail_userLogTab_redshift_userChangeHistory:
    'FILTERSEARCH_database_instanceDetail_userLogTab_redshift_userChangeHistory',
  FILTERSEARCH_database_instanceDetail_slowQueryTab_redshift_slowQuery:
    'FILTERSEARCH_database_instanceDetail_slowQueryTab_redshift_slowQuery',

  // session detail
  GRIDCOLUMNS_database_redshiftSessionDetail_activeSessionHistory:
    'GRIDCOLUMNS_database_redshiftSessionDetail_activeSessionHistory',
  GRIDCOLUMNS_database_redshiftSessionDetail_plan:
    'GRIDCOLUMNS_database_redshiftSessionDetail_plan',
  FILTERSEARCH_database_sessionDetail_redshift_sessionHistoryList:
    'FILTERSEARCH_database_sessionDetail_redshift_sessionHistoryList',
  TAB_database_redshiftSessionDetail_selected: 'TAB_database_redshiftSessionDetail_selected',

  // sql detail
  GRIDCOLUMNS_database_redshiftSqlDetail_plan: 'GRIDCOLUMNS_database_redshiftSqlDetail_plan',
  GRIDCOLUMNS_database_redshiftSqlDetail_sqlHistory:
    'GRIDCOLUMNS_database_redshiftSqlDetail_sqlHistory',
  FILTERSEARCH_database_redshiftSqlDetail_plan: 'FILTERSEARCH_database_redshiftSqlDetail_plan',
  FILTERSEARCH_database_redshiftSqlDetail_sqlHistory:
    'FILTERSEARCH_database_redshiftSqlDetail_sqlHistory',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_redshift_parameterList:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_redshift_parameterList',
  FILTERSEARCH_database_instanceDetail_parameterDetail_redshift_parameterList:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_redshift_parameterList',
};

const SINGLESTORE_ENVS = {
  SINGLESTORE_CLUSTER_VIEW_SELECTED_ID: 'SINGLESTORE_CLUSTER_VIEW_SELECTED_ID',

  // cluster detail
  GRIDCOLUMNS_database_singlestoreClusterDetail_clusterInfo:
    'GRIDCOLUMNS_database_singlestoreClusterDetail_clusterInfo',
  FILTERSEARCH_database_singlestoreClusterDetail_clusterInfo:
    'FILTERSEARCH_database_singlestoreClusterDetail_clusterInfo',

  GRIDCOLUMNS_database_singlestoreClusterDetail_databaseInfo:
    'GRIDCOLUMNS_database_singlestoreClusterDetail_databaseInfo',
  FILTERSEARCH_database_singlestoreClusterDetail_databaseInfo:
    'FILTERSEARCH_database_singlestoreClusterDetail_databaseInfo',

  GRIDCOLUMNS_database_singlestoreClusterDetail_partitionInfo:
    'GRIDCOLUMNS_database_singlestoreClusterDetail_partitionInfo',
  FILTERSEARCH_database_singlestoreClusterDetail_partitionInfo:
    'FILTERSEARCH_database_singlestoreClusterDetail_partitionInfo',

  GRIDCOLUMNS_database_singlestoreClusterDetail_activeQuery:
    'GRIDCOLUMNS_database_singlestoreClusterDetail_activeQuery',
  FILTERSEARCH_database_singlestoreClusterDetail_activeQuery:
    'FILTERSEARCH_database_singlestoreClusterDetail_activeQuery',

  GRIDCOLUMNS_database_singlestoreClusterDetail_sqlList:
    'GRIDCOLUMNS_database_singlestoreClusterDetail_sqlList',
  FILTERSEARCH_database_singlestoreClusterDetail_sqlList:
    'FILTERSEARCH_database_singlestoreClusterDetail_sqlList',

  GRIDCOLUMNS_database_singlestoreClusterDetail_eventList:
    'GRIDCOLUMNS_database_singlestoreClusterDetail_eventList',
  FILTERSEARCH_database_singlestoreClusterDetail_eventList:
    'FILTERSEARCH_database_singlestoreClusterDetail_eventList',

  GRIDCOLUMNS_database_singlestoreClusterDetail_parameter:
    'GRIDCOLUMNS_database_singlestoreClusterDetail_parameter',
  FILTERSEARCH_database_singlestoreClusterDetail_parameter:
    'FILTERSEARCH_database_singlestoreClusterDetail_parameter',

  // instance detail
  GRIDCOLUMNS_database_singlestoreInstanceDetail_parameterList:
    'GRIDCOLUMNS_database_singlestoreInstanceDetail_parameterList',
  FILTERSEARCH_database_singlestoreInstanceDetail_parameterList:
    'FILTERSEARCH_database_singlestoreInstanceDetail_parameterList',

  // session detail
  GRIDCOLUMNS_database_singlestoreSessionDetail_queryInfo:
    'GRIDCOLUMNS_database_singlestoreSessionDetail_queryInfo',
  FILTERSEARCH_database_singlestoreSessionDetail_queryInfo:
    'FILTERSEARCH_database_singlestoreSessionDetail_queryInfo',

  // sql detail
  GRIDCOLUMNS_database_singlestoreSqlDetail_nodeStat:
    'GRIDCOLUMNS_database_singlestoreSqlDetail_nodeStat',
  FILTERSEARCH_database_singlestoreSqlDetail_nodeStat:
    'FILTERSEARCH_database_singlestoreSqlDetail_nodeStat',

  GRIDCOLUMNS_database_singlestoreSqlDetail_sqlHistory:
    'GRIDCOLUMNS_database_singlestoreSqlDetail_sqlHistory',
  FILTERSEARCH_database_singlestoreSqlDetail_sqlHistory:
    'FILTERSEARCH_database_singlestoreSqlDetail_sqlHistory',

  GRIDCOLUMNS_database_singlestoreSqlDetail_plan: 'GRIDCOLUMNS_database_singlestoreSqlDetail_plan',

  // parameter detail
  GRIDCOLUMNS_database_instanceDetail_parameterDetail_singlestore_parameter:
    'GRIDCOLUMNS_database_instanceDetail_parameterDetail_singlestore_parameter',
  FILTERSEARCH_database_instanceDetail_parameterDetail_singlestore_parameter:
    'FILTERSEARCH_database_instanceDetail_parameterDetail_singlestore_parameter',

  METRIC_database_instanceView_instanceDetail_singlestore_metricChart:
    'METRIC_database_instanceView_instanceDetail_singlestore_metricChart',
  METRIC_database_instanceView_instanceClusterDetail_singlestore_metricChart:
    'METRIC_database_instanceView_instanceClusterDetail_singlestore_metricChart',

  // multiView (clusterview)
  GRIDCOLUMNS_database_singlestoreMultiView_rankAlertLogs:
    'GRIDCOLUMNS_database_singlestoreMultiView _rankAlertLogs',
  FILTERSEARCH_database_singlestoreMultiView_rankAlertLogs:
    'FILTERSEARCH_database_singlestoreMultiView_rankAlertLogs',

  GRIDCOLUMNS_database_singlestoreMultiView_activeQueryTable:
    'GRIDCOLUMNS_database_singlestoreMultiView_activeQueryTable',
  FILTERSEARCH_database_singlestoreMultiView_activeQueryTable:
    'FILTERSEARCH_database_singlestoreMultiView_activeQueryTable',

  METRIC_database_singlestoreMultiView_total_value:
    'METRIC_database_singlestoreMultiview_total_value',

  GRIDCOLUMNS_database_singlestoreClusterView_diskUsageWindow:
    'GRIDCOLUMNS_database_singlestoreClusterView_diskUsageWindow',
  FILTERSEARCH_database_singlestoreClusterView_diskUsageWindow:
    'FILTERSEARCH_database_singlestoreClusterView_diskUsageWindow',
  GRIDCOLUMNS_database_singlestoreClusterView_totalMemoryUsedWindow:
    'GRIDCOLUMNS_database_singlestoreClusterView_totalMemoryUsedWindow',
  FILTERSEARCH_database_singlestoreClusterView_totalMemoryUsedWindow:
    'FILTERSEARCH_database_singlestoreClusterView_totalMemoryUsedWindow',
  GRIDCOLUMNS_database_singlestoreClusterView_pipelineErrorWindow:
    'GRIDCOLUMNS_database_singlestoreClusterView_pipelineErrorWindow',
  FILTERSEARCH_database_singlestoreClusterView_pipelineErrorWindow:
    'FILTERSEARCH_database_singlestoreClusterView_pipelineErrorWindow',
  GRIDCOLUMNS_database_singlestoreClusterView_topPartitionWindow:
    'GRIDCOLUMNS_database_singlestoreClusterView_topPartitionWindow',
  FILTERSEARCH_database_singlestoreClusterView_topPartitionWindow:
    'FILTERSEARCH_database_singlestoreClusterView_topPartitionWindow',
  GRIDCOLUMNS_database_singlestoreClusterView_topQueryWindow:
    'GRIDCOLUMNS_database_singlestoreClusterView_topQueryWindow',
  FILTERSEARCH_database_singlestoreClusterView_topQueryWindow:
    'FILTERSEARCH_database_singlestoreClusterView_topQueryWindow',
};

const LOGICAL_DATABASE_ENVS = {
  // database-specific
  GRIDCOLUMNS_database_slowQuery_sqlHistory: 'GRIDCOLUMNS_database_slowQuery_sqlHistory',
  FILTERSEARCH_database_slowQuery_sqlHistory: 'FILTERSEARCH_database_slowQuery_sqlHistory',
  GRIDCOLUMNS_database_slowQueryDetail_plan: 'GRIDCOLUMNS_database_slowQueryDetail_plan',
};

const ACTIVE_QUERY_DETAIL_ENVS = {
  GRIDCOLUMNS_database_singlestoreActiveQueryDetail_queryInfo:
    'GRIDCOLUMNS_database_singlestoreActiveQueryDetail_queryInfo',
  FILTERSEARCH_database_singlestoreActiveQueryDetail_queryInfo:
    'FILTERSEARCH_database_singlestoreActiveQueryDetail_queryInfo',
};

export const DATABASE = {
  ...ORACLE_ENVS,
  ...POSTGRESQL_ENVS,
  ...MYSQL_ENVS,
  ...SQLSERVER_ENVS,
  ...CUBRID_ENVS,
  ...MONGO_ENVS,
  ...REDIS_ENVS,
  ...ALTIBASE_ENVS,
  ...TIBERO_ENVS,
  ...CLICKHOUSE_ENVS,
  ...REDSHIFT_ENVS,
  ...SINGLESTORE_ENVS,
  ...LOGICAL_DATABASE_ENVS,
  ...ACTIVE_QUERY_DETAIL_ENVS,

  GRIDCOLUMNS_database_instance_instanceList: 'GRIDCOLUMNS_database_instance_instanceList',
  FILTERSEARCH_database_instanceView_instanceList:
    'FILTERSEARCH_database_instanceView_instanceList',
  FILTER_database_instanceView: 'FILTER_database_instanceView',

  // database-specific tabs
  GRIDCOLUMNS_database_instanceDetail_clientList: 'GRIDCOLUMNS_database_instanceDetail_clientList',
  GRIDCOLUMNS_database_instanceDetail_commandStat:
    'GRIDCOLUMNS_database_instanceDetail_commandStat',
  GRIDCOLUMNS_database_instanceDetail_log: 'GRIDCOLUMNS_database_instanceDetail_log',
  GRIDCOLUMNS_database_instanceDetail_cloudEvent: 'GRIDCOLUMNS_database_instanceDetail_cloudEvent',
  GRIDCOLUMNS_database_clusterDetail_clusterMap: 'GRIDCOLUMNS_database_clusterDetail_clusterMap',
  GRIDCOLUMNS_database_instanceDetail_keyBrowser: 'GRIDCOLUMNS_database_instanceDetail_keyBrowser',
  FILTERSEARCH_database_instanceDetail_clientListTab_clientList:
    'FILTERSEARCH_database_instanceDetail_clientListTab_clientList',
  FILTERSEARCH_database_instanceDetail_commandStatTab_commandStatList:
    'FILTERSEARCH_database_instanceDetail_commandStatTab_commandStatList',

  // dashboard jump setting
  TAB_database_instanceDetail_selected: 'TAB_database_instanceDetail_selected',
  TAB_database_clusterDetail_selected: 'TAB_database_clusterDetail_selected',
  DATABASE_INSTANCE_DETAIL_DASHBOARD_SETTING_LIST:
    'DATABASE_INSTANCE_DETAIL_DASHBOARD_SETTING_LIST',
  DATABASE_BROKER_DETAIL_DASHBOARD_SETTING_LIST: 'DATABASE_BROKER_DETAIL_DASHBOARD_SETTING_LIST',
  DATABASE_INSTANCE_CLUSTER_DETAIL_DASHBOARD_SETTING_LIST:
    'DATABASE_INSTANCE_CLUSTER_DETAIL_DASHBOARD_SETTING_LIST',
  GRIDCOLUMNS_database_rtm_alertLogs: 'GRIDCOLUMNS_database_rtm_alertLogs',

  GRIDCOLUMNS_database_sql_text_window_sqlPlan_oracle:
    'GRIDCOLUMNS_database_sql_text_window_sqlPlan_oracle',
  GRIDCOLUMNS_database_sql_text_window_sqlPlan_postgresql:
    'GRIDCOLUMNS_database_sql_text_window_sqlPlan_postgresql',
  GRIDCOLUMNS_database_sql_text_window_sqlPlan_mysql:
    'GRIDCOLUMNS_database_sql_text_window_sqlPlan_mysql',
  GRIDCOLUMNS_database_sql_text_window_sqlPlan_sqlserver:
    'GRIDCOLUMNS_database_sql_text_window_sqlPlan_sqlserver',
  GRIDCOLUMNS_database_sql_text_window_sqlPlan_tibero:
    'GRIDCOLUMNS_database_sql_text_window_sqlPlan_tibero',
  GRIDCOLUMNS_database_sql_text_window_sqlPlan_altibase:
    'GRIDCOLUMNS_database_sql_text_window_sqlPlan_altibase',
  GRIDCOLUMNS_database_sql_text_window_sqlPlan_clickhouse:
    'GRIDCOLUMNS_database_sql_text_window_sqlPlan_clickhouse',
  GRIDCOLUMNS_database_sql_text_window_sqlPlan_redshift:
    'GRIDCOLUMNS_database_sql_text_window_sqlPlan_redshift',

  AI_MODE_database_instanceDetail: 'AI_MODE_database_instanceDetail',

  OVERVIEW_DATABASE_GROUP_INFO: 'OVERVIEW_DATABASE_GROUP_INFO',

  TOGGLE_database_replicationDetail_info_expanded:
    'TOGGLE_database_replicationDetail_info_expanded',
  TOGGLE_database_replicationDetail_sender_expanded:
    'TOGGLE_database_replicationDetail_sender_expanded',
  TOGGLE_database_replicationDetail_receiver_expanded:
    'TOGGLE_database_replicationDetail_receiver_expanded',

  TOGGLE_database_instanceDetail_haTab_replicationMap_expanded:
    'TOGGLE_database_instanceDetail_haTab_replicationMap_expanded',

  TOGGLE_database_keyBrowserDetail_keyInfo_expanded:
    'TOGGLE_database_keyBrowserDetail_keyInfo_expanded',
  TOGGLE_database_keyBrowserDetail_searchOption_expanded:
    'TOGGLE_database_keyBrowserDetail_searchOption_expanded',
  TOGGLE_database_keyBrowserDetail_scanOption_expanded:
    'TOGGLE_database_keyBrowserDetail_scanOption_expanded',
  TOGGLE_database_instanceDetail_cubridBrokerMap_expanded:
    'TOGGLE_database_instanceDetail_cubridBrokerMap_expanded',
  TOGGLE_database_instanceDetail_replicationMap_expanded:
    'TOGGLE_database_instanceDetail_replicationMap_expanded',
  TOGGLE_database_replicationDetail_connectionRelationships_expanded:
    'TOGGLE_database_replicationDetail_connectionRelationships_expanded',

  TOGGLE_database_instanceDetail_textLog_queryOption_expanded:
    'TOGGLE_database_instanceDetail_textLog_queryOption_expanded',
  TOGGLE_database_instanceDetail_queryLog_queryOption_expanded:
    'TOGGLE_database_instanceDetail_queryLog_queryOption_expanded',
  TOGGLE_database_instanceDetail_partLog_queryOption_expanded:
    'TOGGLE_database_instanceDetail_partLog_queryOption_expanded',
  TAB_database_activeQueryDetail_selected: 'TAB_database_activeQueryDetail_selected',
  TAB_database_replicationDetail_selected: 'TAB_database_replicationDetail_selected',
  TAB_database_slowQueryDetail_selected: 'TAB_database_slowQueryDetail_selected',
  TAB_database_brokerDetail_selected: 'TAB_database_brokerDetail_selected',
  TAB_database_objectDetail_selected: 'TAB_database_objectDetail_selected',
  TAB_database_sqlDetail_selected: 'TAB_database_sqlDetail_selected',
};
